/**
 * SkeletonRow — loading placeholder.
 *
 * Replaces the inline `<div className="h-24 bg-gray-200 rounded-lg animate-pulse">` blocks
 * scattered across SearchPage, WatchlistPage, and SchoolDetailPage.
 *
 * Motion: uses `motion-safe:animate-pulse` so the animation is suppressed for users
 * who have opted into prefers-reduced-motion. The element is aria-hidden because it
 * carries no information — the parent sets aria-busy + aria-label on the container.
 *
 * No Radix dependency.
 */

import React from 'react';

interface Props {
  /** Tailwind height class. Default h-24 matches the result-card height. */
  height?: string;
  className?: string;
}

export function SkeletonRow({ height = 'h-24', className = '' }: Props) {
  return (
    <div
      aria-hidden="true"
      className={`bg-gray-200 rounded-lg motion-safe:animate-pulse ${height} ${className}`}
    />
  );
}
